import { Sparkles, Package, RotateCcw, Truck } from "lucide-react";

/**
 * Social-proof strip on the homepage — surfaces the guarantees that
 * matter to hesitant first-time luxury buyers. All four claims are
 * policy-backed (not visitor-count metrics) so they hold up under
 * scrutiny and never drift out of date.
 */
const STATS = [
  { Icon: Sparkles, value: "Curated Weekly", label: "100+ new drops" },
  { Icon: Package, value: "White-Glove", label: "Packaging" },
  { Icon: RotateCcw, value: "7-Day", label: "Easy Returns" },
  { Icon: Truck, value: "Pan India", label: "Free Shipping" },
];

const HomeSocialProof = () => (
  <section
    className="lux-container mt-6 md:mt-10"
    data-testid="home-social-proof"
  >
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 py-6 md:py-8 border-y border-black/10 bg-neutral-50/50">
      {STATS.map(({ Icon, value, label }) => (
        <div
          key={label}
          className="flex flex-col items-center text-center gap-1.5"
          data-testid={`social-proof-stat-${label.toLowerCase().replace(/\s+/g, "-")}`}
        >
          <Icon
            className="w-5 h-5 md:w-6 md:h-6 text-neutral-600"
            strokeWidth={1.5}
          />
          <div className="font-serif-display text-xl md:text-2xl leading-none">
            {value}
          </div>
          <div className="text-[10px] md:text-[11px] uppercase tracking-[0.14em] text-neutral-500">
            {label}
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default HomeSocialProof;
